import { render, staticRenderFns } from "./view-pdf.vue?vue&type=template&id=2321501d"
import script from "./view-pdf.vue?vue&type=script&lang=js"
export * from "./view-pdf.vue?vue&type=script&lang=js"
import style0 from "./view-pdf.vue?vue&type=style&index=0&id=2321501d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports